document.addEventListener("DOMContentLoaded", function () {

  const quizData = JSON.parse(localStorage.getItem("quizData")) || {};

  // Reference keys ko ek baar lowercase me convert kar do
  const userRefKeys = (quizData["reference_key"] || []).map(k =>
    k.toLowerCase().trim()
  );

  const container = document.querySelector(".products-container");
  const card = document.querySelectorAll(".card");
  const card_image_planet = document.querySelectorAll(".card-image-planet");
  const card_image_bottle = document.querySelectorAll(".card-image-bottle");
  const productCards = document.querySelectorAll(".products-container a");

  let matchFound = false;

  // Pehle check: koi bhi card match karta hai ya nahi
  productCards.forEach(card => {
    const productKey = card.dataset.referenceKey
      .toLowerCase()
      .trim();

    if (userRefKeys.includes(productKey)) {
      matchFound = true;
    }
  });

  // Agar match hi nahi mila → kuch hide nahi karna
  if (!matchFound) {
    return;
  }

  // Sirf wahi cards dikhao jo reference_key array me hain
  productCards.forEach(card => {
    const productKey = card.dataset.referenceKey
      .toLowerCase()
      .trim();

    if (!userRefKeys.includes(productKey)) {
      card.style.display = "none";
    }
  });

  // Visible cards count karo
  const visibleCards = Array.from(productCards).filter(
    c => c.style.display !== "none"
  );

      // COUNT PRODUCTS
    const updateGetAllCount = () => {
      const count = visibleCards.length;

      const desktopBtn = document.getElementById('buy-all');
      const mobileBtn = document.getElementById('buy-all-mobile');

      if (desktopBtn) desktopBtn.innerText = `Get all ${count}`;
      if (mobileBtn) mobileBtn.innerText = `Get all ${count}`;
    };
    updateGetAllCount();

  if (visibleCards.length === 1) {
    container.classList.add("one-card");

    card.forEach(c => {
      c.classList.add("single-card-ratio");
    });

    // planet
    card_image_planet.forEach(planet => {
      planet.classList.add("card-image-planet-single-card");
    });

    // bottle
    card_image_bottle.forEach(bottle => {
      bottle.classList.add("card-image-bottle-single-card");
    });

  } 
  else if (visibleCards.length === 2) {
    container.classList.add("two-cards");

    card.forEach(c => {
      c.classList.add("two-card-ratio");
    });

    // planet
    card_image_planet.forEach(planet => {
      planet.classList.add("card-image-planet-two-card");
    });

    // bottle
    card_image_bottle.forEach(bottle => {
      bottle.classList.add("card-image-bottle-two-card");
    });
  }

});